export default __webpack_public_path__ + "static/media/rede4.fw.430f3199.png";